// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserAvatar_avatar__1-vc7"};